import React, { createContext, useState, useContext } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [ isAuthenticated, setIsAuthenticated ] = useState(false);
    const [ user, setUser ] = useState(null);
    const [ session, setSession ] = useState(null);
    const login = (callback) => {
        setIsAuthenticated(true);
        callback();
    };

    const logout = async (callback) => {
        try {
            await axios({
                method: 'post',
                url: 'https://signupapp-backend-app-9b09cbe965e9.herokuapp.com/api/restricted/logout',
                data: {session}
            }).then(() => {
                setUser(null);
                setSession(null);
                setIsAuthenticated(false);
                callback();
            });
        } catch(error) {
            console.log(error)
        };
    };
    return (
        <AuthContext.Provider value={{ session, setSession, user, setUser, isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};